<template>
	<div class="relative">
		<span v-if="accounts?.length === 1" class="mx-2">
			<slot />
		</span>
		<button
			v-else
			:aria-expanded="`${show}`"
			:aria-controls="`accountSwitchButton_${_uid}_content`"
			:class="buttonClass"
			@click="show = !show"
		>
			<span class="leading-6">
				<slot />
			</span>
			<nuxt-icon filled
        class="transition fill-current text-grey mx-2 h-2.5 w-2.5"
				:style="show ? 'transform: rotateX(-180deg);' : ''"
				name="chevron-down" />
		</button>

		<transition name="transition--fade">
			<div
				v-show="show"
				:id="`accountSwitchButton_${_uid}_content`"
				:aria-hidden="`${!show}`"
				class="absolute z-40 min-w-full w-48 bg-cyan-lighter border-2 border-blue-lighter shadow"
			>
				<div v-for="(group, index) in groups" :key="group.name">
					<div
						class="pt-3 px-3 pb-1 text-xs text-grey"
						:class="{ 'border-t-2 border-blue-lightest pt-6': index > 0 }"
					>
						{{ group.name }}
						<span class="text-xs">({{ t(getRole(group.role).name) }})</span>
					</div>
					<nuxt-link
						v-for="account in group.accounts"
						:key="account.id"
						:to="account.path"
						class="group transition flex border-t-2 border-blue-lightest p-3 text-black no-underline hover:bg-white focus:bg-white"
						active-class="bg-white"
						@click.native="show = false"
					>
						<nuxt-icon filled
							class="mr-2 fill-current text-transparent h-4 w-4"
							:class="{
								'text-blue': account.id == activeAccountId,
								'group-hover:text-blue-lightest': account.id != activeAccountId,
							}" name="check" />
						{{ account.name }}
					</nuxt-link>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
import { CUSTOMER_ROLES } from '~/constants/customer'
import {useAccountService} from "~/services/account";
import {useAccountId} from "~/composables/useAccountId";

export default {
	props: {
		buttonClass: {
			type: String,
			default: '',
		},
	},
  setup() {
    const { t } = useTranslation()
    const { accountsQuery, accountRoles: roles } = useAccountService();
    const { data: accounts } = accountsQuery()
    const activeAccountId = useAccountId()

    return {
      t,
      activeAccountId,
      accounts,
      roles,
    }
  },
	data() {
		return {
			show: false,
		}
	},
	computed: {
		groups() {
			const groups = []
			const groupIds = []

			this.accounts?.forEach((account) => {
				const existingIndex = groupIds.findIndex(
					(id) => id === (account.EntrepreneurId || account.AccountId)
				)
				const id = account.AccountId
				const name = this.getName(account)
				const pathPrefix =
					(CUSTOMER_ROLES.find((role) => role.id === account.Role) &&
						CUSTOMER_ROLES.find((role) => role.id === account.Role).path) ||
					''
				const path = `/${pathPrefix}/${id}`
				if (existingIndex > -1) {
					groups[existingIndex].accounts.push({ id, name, path })
				} else {
					groupIds.push(account.EntrepreneurId || account.AccountId)
					groups.push({
						name: account.EntrepreneurName || account.AccountName,
						role: account.Role,
						accounts: [{ id, name, path }],
					})
				}
			})

			return groups
		},
	},
	mounted() {
		document.addEventListener('click', this.eventHide)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.eventHide)
	},
	methods: {
		getName(account) {
			if (account.AccessLevel === 1) {
				return 'ADMIN'
			}

			return account.AccountName || 'NN'
		},
		getRole(roleId) {
			return (
				(this.roles &&
					Array.isArray(this.roles) &&
					this.roles.find((role) => role.id === roleId)) || {
					name: 'UNKNOWN',
				}
			)
		},
		eventHide(event) {
			if (!this.$el.contains(event.target)) {
				this.show = false
			}
		},
	},
}
</script>
